export default "__VITE_ASSET__OC86ILAB__"